
<template>
  <div class="layout-footer">
    <div class="copyright">&copy; One Better co.,Ltd. ALL RIGHTS RESERVED.</div>
  </div>
</template>
